import Swiper, { Pagination, Autoplay } from 'swiper';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import HorizontalScroll from './HorizontalScroll';
import ResponsiveSwiper from './ResponsiveSwiper';
import MediaTextSlider from './MediaTextSlider';
import AnchorLinks from './AnchorLinks';
import Marquee from './Marquee';
import Accordion from './Accordion';

gsap.registerPlugin(ScrollTrigger);

class GeneralBlocks {
  constructor(wWidth) {
    this.initFullWidthMedia();
    this.initSpecialsAccordion();
    this.initSingleMediaSlider();
    this.initDividerWaves();
    this.initMediaStoryteller();
    this.initInstagram();
    //this.initBookingToggle();

    this.horizontal = $('.horizontal').map(
      (i, el) => new HorizontalScroll(el, wWidth)
    );
    this.moodboard = $('.moodboard').map(
      (i, el) => new ResponsiveSwiper(el, wWidth)
    );
    this.gridSwiper = $('.grid-layout--swiper').map(
      (i, el) => new ResponsiveSwiper(el, wWidth)
    );
    this.latestPosts = $('.latest-posts').map(
      (i, el) => new ResponsiveSwiper(el, wWidth)
    );
    this.mediaTextSlider = $('.media-text-slider').map(
      (i, el) => new MediaTextSlider(el, wWidth)
    );
    this.anchorLinks = $('.anchor-links').map(
      (i, el) => new AnchorLinks(el, wWidth)
    );

    this.accordions = $('.accordion').map((i, el) => new Accordion(el));
  }

  onResize(wWidth) {
    this.moodboard.each((i, el) => {
      if (el.onResize) el.onResize(wWidth);
    });
    this.mediaTextSlider.each((i, el) => {
      if (el.onResize) el.onResize(wWidth);
    });
    this.gridSwiper.each((i, el) => {
      if (el.onResize) el.onResize(wWidth);
    });
    this.latestPosts.each((i, el) => {
      if (el.onResize) el.onResize(wWidth);
    });
    this.anchorLinks.each((i, el) => {
      if (el.onResize) el.onResize(wWidth);
    });
  }

  initInstagram() {
    const $blocks = $('.instagram');
    if (!$blocks.length) return;
    const $imagesContainer = $blocks.find('.instagram__images');
    const $imagesRow = $imagesContainer.children('.instagram__row');
    const rowWidth = $imagesRow.width();
    const timesToClone = rowWidth < this.wWidth ? 3 : 1;

    // clone row N times
    for (let i = 0; i < timesToClone; i += 1) {
      $imagesRow.clone().appendTo($imagesContainer);
    }

    this.instagram = $('.js-marquee').map((i, el) => new Marquee(el));
  }

  initFullWidthMedia() {
    this.$fullWidthMedias = $('.full-width-media');
    if (!this.$fullWidthMedias.length) return;

    this.$fullWidthMedias.each((i, el) => {
      const $swiper = $(el).find('.full-width-media__swiper');
      const $pagination = $(el).find('.swiper-pagination');

      // eslint-disable-next-line no-new
      new Swiper($swiper[0], {
        loop: true,
        modules: [Pagination, Autoplay],
        speed: 700,
        autoplay: {
          delay: 4000,
        },
        pagination: {
          el: $pagination.get(0),
          type: 'bullets',
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className}"><img src="${theme.uri}/img/icon-bullet.svg" alt="Bullet"/></span>`;
          },
        },
      });
    });
  }

  initSingleMediaSlider() {
    this.$singleMediaSlider = $('.single-media-slider');
    if (!this.$singleMediaSlider.length) return;

    this.$singleMediaSlider.each((i, el) => {
      const $swiper = $(el).find('.single-media-slider__swiper');
      const $pagination = $(el).find('.swiper-pagination');

      // eslint-disable-next-line no-new
      new Swiper($swiper[0], {
        loop: true,
        modules: [Pagination],
        pagination: {
          el: $pagination.get(0),
          type: 'bullets',
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className}"><img src="${theme.uri}/img/icon-bullet-red.svg" alt="Bullet"/></span>`;
          },
        },
      });
    });
  }

  initSpecialsAccordion() {
    this.$specials = $('.specials');
    if (!this.$specials.length) return;

    this.$specials.each((i, el) => {
      const $block = $(el);
      const $accordion = $block.find('.specials__accordion');
      const $btn = $accordion.children('.specials__accordion-btn');
      const $content = $accordion.children('.specials__accordion-content');

      $btn.on('click', (e) => {
        const $cur = $(e.currentTarget);
        const $curRow = $cur.parent();
        if (!$curRow.hasClass('is-opened')) {
          $accordion.removeClass('is-opened');
          $content.slideUp();
          $curRow
            .addClass('is-opened')
            .children('.specials__accordion-content')
            .slideDown();
        } else {
          $curRow
            .removeClass('is-opened')
            .children('.specials__accordion-content')
            .slideUp();
        }
      });
    });
  }

  initDividerWaves() {
    this.$dividerWaves = $('.divider-wave');
    if (!this.$dividerWaves.length) return;

    this.$dividerWaves.each((i, el) => {
      const $block = $(el);
      const $inner = $block.find('.divider-wave__inner');
      const speed = $inner.width() / 80;

      gsap.to($inner.get(0), {
        scrollTrigger: {
          trigger: $block.get(0),
          start: 'top bottom',
          end: 'bottom top',
          scrub: 2,
        },
        x: '-50%',
        duration: speed,
      });
    });
  }

  initMediaStoryteller() {
    this.$mediaStorytellers = $('.media-storyteller');
    if (!this.$mediaStorytellers.length) return;

    this.$mediaStorytellers.each((i, el) => {
      const $block = $(el);
      const $swiper = $block.find('.media-storyteller__swiper');
      const $pagination = $block.find('.media-storyteller__pagination');
      if (!$swiper.length) return;

      // eslint-disable-next-line no-new
      new Swiper($swiper[0], {
        loop: true,
        modules: [Pagination, Autoplay],
        speed: 700,
        autoplay: {
          delay: 4000,
        },
        pagination: {
          el: $pagination[0],
          type: 'bullets',
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className}"><img src="${theme.uri}/img/icon-bullet-red.svg" alt="Bullet"/></span>`;
          },
        },
      });
    });
  }

  initBookingToggle() {
    document.getElementById("toggleButton").addEventListener("click", function () {
        var restaurants = document.querySelectorAll(".map__block.map__restaurants .map__restaurant");
        var listItems = document.querySelectorAll('.search__option');
    
        for (var i = 0; i < restaurants.length; i++) {
            var widgetId = restaurants[i].getAttribute("data-widget-id");
            var listItemswidgetId = listItems[i].getAttribute('data-widget-id');

            if (widgetId === "" || !listItemswidgetId) {
                restaurants[i].style.display = (restaurants[i].style.display === "none") ? "block" : "none";
                listItems[i].style.display = (listItems[i].style.display === 'none') ? 'block' : 'none';
            }
        }
    });
  }
}

export default GeneralBlocks;
